/**
 * Layout for /jobs: authenticated users get AppShell; guests get a light top bar.
 */
import React from 'react';
import { Link as RouterLink, Outlet, Navigate } from 'react-router-dom';
import { Box, Button, CircularProgress, Typography } from '@mui/material';
import { useAuth } from '../contexts/AuthContext';
import PublicHiringFooter from '../components/hiring/PublicHiringFooter';

export default function JobsDiscoveryLayout() {
  const { isAuthenticated, loading } = useAuth();

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '40vh' }}>
        <CircularProgress size={40} />
      </Box>
    );
  }

  if (isAuthenticated) {
    return <Navigate to="/browse-jobs" replace />;
  }

  return (
    <>
      <Box
        sx={{
          px: 2,
          py: 1.5,
          display: 'flex',
          flexWrap: 'wrap',
          gap: 1,
          alignItems: 'center',
          justifyContent: 'space-between',
          borderBottom: 1,
          borderColor: 'divider',
          bgcolor: '#fafafa',
        }}
      >
        <Typography
          component={RouterLink}
          to="/landing"
          variant="subtitle1"
          sx={{
            fontWeight: 700,
            color: 'primary.main',
            textDecoration: 'none',
            '&:hover': { textDecoration: 'underline' },
          }}
        >
          JobMockAI
        </Typography>
        <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
          <Button component={RouterLink} to="/login" variant="outlined" size="small">
            Sign in
          </Button>
          <Button component={RouterLink} to="/register" variant="contained" size="small" sx={{ bgcolor: '#3b82f6' }}>
            Sign up
          </Button>
        </Box>
      </Box>
      <Outlet />
      <PublicHiringFooter />
    </>
  );
}
